
import { getPlaceList } from '@/api/place';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})

export default class extends Vue {
  mounted() {
    this.initKakao();
  }

  private makerList: any = [];

  private placeList = [];

  private loading = true;

  private type = 'TOURLIST';

  private typeList = [
    { label: '관광지', value: 'TOURLIST' },
    { label: '주차장', value: 'PARKING' },
    { label: '정류장', value: 'STOP' },
    { label: '화장실', value: 'TOILET' },
  ]

  private map = null;

  private overlayList: any = [];

  private initKakao() {
    const start = () => {
      const kakaoMaps = (window as any).kakao && (window as any).kakao.maps;
      if (!kakaoMaps) return;

      // SDK가 `autoload=false`로 로드된 경우 `kakao.maps.load()` 호출 전에는 LatLng 등이 준비되지 않습니다.
      if (typeof kakaoMaps.load === 'function') {
        kakaoMaps.load(() => {
          this.initMap();
          this.getPlaceList();
        });
        return;
      }

      this.initMap();
      this.getPlaceList();
    };

    if ((window as any).kakao && (window as any).kakao.maps) {
      start();
      return;
    }

    // index.html에서 defer로 SDK 로드 중 — 로드 완료 대기
    const interval = setInterval(() => {
      if ((window as any).kakao && (window as any).kakao.maps) {
        clearInterval(interval);
        start();
      }
    }, 100);
  }

  /* eslint-disable */
  private initMap() {
    const kakaoMaps = (window as any).kakao && (window as any).kakao.maps;
    if (!kakaoMaps) return;

    // Defensive: in some builds the loader calls `load()` but LatLng is still not ready immediately.
    if (typeof kakaoMaps.LatLng !== 'function') {
      if (typeof kakaoMaps.load === 'function') {
        kakaoMaps.load(() => {
          if (typeof kakaoMaps.LatLng === 'function') this.initMap();
        });
      }
      return;
    }

    const container = document.getElementById('map');
    const option = {
      center: new (window as any).kakao.maps.LatLng(34.801194687587945, 127.94185477615481),
      level: 8,
    };
    this.map = new (window as any).kakao.maps.Map(container, option);
  }

  private getPlaceList() {
    this.loading = true;
    this.overlayList.forEach((overlay: any) => overlay.setMap(null));
    this.overlayList = [];
    getPlaceList(this.type).then((res) => {
      this.loading = false;
      this.placeList = res.data;
      this.addMarkers(res.data);
      this.initMarker();
    });
  }

  private initMarker() {
    this.placeList.forEach((place: any) => {
      const markerPosition = new (window as any).kakao.maps.LatLng(place.lat, place.lng);

      // const imageSrc = 'http://t1.daumcdn.net/mapjsapi/images/marker.png';
      const imageSrc = '/img/map_marker.png';
      const imageSize = new (window as any).kakao.maps.Size(29, 42);

      // 마커의 이미지정보를 가지고 있는 마커이미지를 생성합니다
      const markerImage = new (window as any).kakao.maps.MarkerImage(imageSrc, imageSize);

      const marker = new (window as any).kakao.maps.Marker({
        position: markerPosition,
        image: markerImage,
      });
      marker.setMap(this.map);
      this.makerList.push(marker);

      // 커스텀 오버레이에 표출될 내용으로 HTML 문자열이나 document element가 가능합니다
      const content = `<div class="gis-item">${place.name}<br>${place.address}</div>`;
      // + `<div class="gis-item__price">55,000</div>` ;

      // 커스텀 오버레이를 생성합니다
      const customOverlay = new (window as any).kakao.maps.CustomOverlay({
        map: null,
        position: markerPosition,
        content,
        yAnchor: 1.9,
        visible: false,
      });

      (window as any).kakao.maps.event.addListener(marker, 'mouseover', () => {
        customOverlay.setMap(this.map);
      });

      (window as any).kakao.maps.event.addListener(marker, 'mouseout', () => {
        customOverlay.setMap(null);
      });

      (window as any).kakao.maps.event.addListener(marker, 'click', function() {
        (window as any).open(`https://map.kakao.com/link/map/${place.name},${place.lat},${place.lng}`);
      });
    });
  }

  private handleClickType(val: any) {
    if (this.type !== val) {
      this.type = val;
      this.getPlaceList();
    }
  }

  private addMarkers(placeList: any) {
    this.initMap();
    placeList.forEach((place: any) => {
      const type = place.type.toLowerCase();
      const markerContent = `
        <div class="overlay">
          <div class="overlay__inner overlay__inner--${type}"></div>
        </div>
      `;
      const position = new (window as any).kakao.maps.LatLng(place.lat, place.lng);
      const overlay = new (window as any).kakao.maps.CustomOverlay({
        position: position,
        content: markerContent,  
      });
      overlay.setMap(this.map);
      this.overlayList.push(overlay);
    });
  }
}
